<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">Add Monthly Income</p-heading>

  <p-text>Are you sure you want to add monthly income?</p-text>

  <p-button-group slot="footer">
    <p-button [loading]="(submitting$ | async) ?? false" (click)="submit()">Add</p-button>
    <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
      Close
    </p-button>
  </p-button-group>
</p-modal>
